/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-globals */
/* eslint-disable max-len */
/* eslint-disable react/button-has-type */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useRef, useState } from 'react';
import {
  parseISO, isValid, startOfDay, endOfDay,
} from 'date-fns';
import { useMantineColorScheme } from '@mantine/core';
import { useClickOutside } from '@mantine/hooks';
import { filterConfigDemo } from '../../../utilities/filterConfigs';
import NewAssetDropDown from './NewAssetDropDown';
// import NewAmountRangeSelector from './NewAmountRangeSelector';
// import NewNumberInputComponent from './NewNumberInput';
import CustomRangeSelector from './CustomRangeSelector';
import CustomPercentageField from './CustomPercentageField';
import ReusableDateRangePicker from './DateRangePicker';

const filterHandlerMap = {
  // dropdown: (item, props, selected) => {
  //   if (!selected || selected.length === 0) return true;

  //   // Special case: Status filter
  //   // if (props.fieldKey === 'status' && props.parentKey === 'runningPnL') {
  //   if (props.enableRangeFilter && props.singleSelectWithRange) {
  //     console.log('selected', selected);
  //     // debugger;
  //     const runningPnL = item.runningPnL?.assetValue ?? 0;
  //     const itemStatus = runningPnL > 0
  //       ? 'In Profit'
  //       : runningPnL < 0
  //         ? 'In Loss'
  //         : 'Break Even';
  //     return selected.includes(itemStatus);
  //   }
  dropdown: (item, props, selected) => {
    if (!selected || selected.length === 0) return true;

    // Special case: Status filter with range
    if (props.enableRangeFilter && props.singleSelectWithRange) {
      // Get the item's value based on parentKey and childKey
      const itemValue = item[props.parentKey]?.[props.childKey] ?? 0;

      // Case 1: When range is selected (array of two numbers)
      if (selected.length === 2 && typeof selected[0] === 'number' && typeof selected[1] === 'number') {
        const [minRange, maxRange] = selected;

        // Check if the item's value falls within the selected range
        return itemValue >= minRange && itemValue <= maxRange;
      }

      // Case 2: When only status is selected (array with one string)
      if (selected.length === 1 && typeof selected[0] === 'string') {
        const statusFilter = selected[0];

        // Determine the item's status based on its value
        const itemStatus = itemValue > 0
          ? 'In Profit'
          : itemValue < 0
            ? 'In Loss'
            : 'Break Even';

        // Check if the item's status matches the selected status
        return statusFilter === itemStatus;
      }
    }

    // General dropdown
    const key = props.fieldKey || props.keyName;
    return selected.includes(item[key]);
  },

  range: (item, props, selectedRange) => {
    if (!Array.isArray(selectedRange) || selectedRange.length !== 2) return true;
    const { parentKey, childKey } = props;
    const rawValue = childKey
      ? item[parentKey]?.[childKey]
      : item[parentKey];
    const value = Number(rawValue);

    return !isNaN(value)
      && value >= selectedRange[0]
      && value <= selectedRange[1];
  },

  // number: (item, props, selectedNumber) => {
  //   if (selectedNumber === undefined || selectedNumber === null) return true;

  //   const rawValue = item[props.parentKey]?.[props.childKey] ?? 0;
  //   const changeInPercent = props?.multiplyBy100 ? rawValue * 100 : rawValue;
  //   const roundedChange = changeInPercent < 0 ? Math.ceil(changeInPercent) : Math.floor(changeInPercent);
  //   return roundedChange === selectedNumber;
  // },
  // number: (item, props, selectedNumber) => {
  //   if (selectedNumber === undefined || selectedNumber === null) return true;

  //   const rawValue = item[props.parentKey]?.[props.childKey] ?? 0;
  //   const changeInPercent = props?.multiplyBy100 ? rawValue * 100 : rawValue;

  //   // Truncate raw data to 2 decimal places (to match UI display logic)
  //   const truncate = (num) => Math.floor(num * 100) / 100;

  //   // Truncate both values to ensure exact match at 2 decimal points
  //   const truncatedChange = parseFloat(changeInPercent.toFixed(2));
  //   const truncatedSelected = truncate(selectedNumber);
  //   console.log('truncatedChange', truncatedChange, '>>>>', truncatedSelected);
  //   return truncatedChange === truncatedSelected;
  // },
  // number: (item, props, selectedNumber) => {
  //   console.log('selectedNumber', selectedNumber);
  //   debugger;
  //   if (selectedNumber === undefined || selectedNumber === null) return true;
  //   let rawValue;
  //   if (props.childKey) {
  //     rawValue = item[props.parentKey]?.[props.childKey] ?? 0;
  //   } else {
  //     rawValue = item[props.parentKey] ?? 0;
  //   }

  //   const changeInPercent = props?.multiplyBy100 ? rawValue * 100 : rawValue;

  //   const formattedChange = parseFloat(changeInPercent.toFixed(2));

  //   const isInteger = selectedNumber === Math.floor(selectedNumber);

  //   if (isInteger) {
  //     return Math.floor(formattedChange) === selectedNumber;
  //   }
  //   return formattedChange === parseFloat(selectedNumber);
  // },
  number: (item, props, selectedNumber) => {
    if (!Array.isArray(selectedNumber) || selectedNumber.length !== 2) return true;
    const { parentKey, childKey } = props;
    let rawValue;
    if (childKey) {
      rawValue = item[parentKey]?.[childKey] ?? 0;
    } else {
      rawValue = item[parentKey] ?? 0;
    }

    const changeInPercent = props.multiplyBy100 ? rawValue * 100 : rawValue;
    const formattedChange = parseFloat(changeInPercent.toFixed(2));

    const min = selectedNumber[0];
    const max = selectedNumber[1];

    if (min != null && formattedChange < min) return false;
    if (max != null && formattedChange > max) return false;

    return true;
  },
  dateRange: (item, props, selectedDateRange) => {
    const [startRaw, endRaw] = selectedDateRange?.dateRange || [];
    if (!startRaw || !endRaw) return true;
    if (!Array.isArray(selectedDateRange?.dateRange) || selectedDateRange?.dateRange.length !== 2) return true;

    const key = props.keyName || props.fieldKey;

    const startDate = startOfDay(selectedDateRange?.dateRange[0]);
    const endDate = endOfDay(selectedDateRange?.dateRange[1]);
    const itemDate = parseISO(item[key]);
    if (!isValid(itemDate)) return false;

    return itemDate >= startDate && itemDate <= endDate;
  },
};

const FilterContainer = ({
  currentTab, data, setData, isModalOpen, setIsModalOpen,
  originalData, appliedFilters, setAppliedFilters, handleClear, resetTrigger,
}) => {
  // const [filterValues, setFilterValues] = useState({});
  const [localFilterValues, setLocalFilterValues] = useState({});
  // const [filteredData, setFilteredData] = useState(data);

  const { colorScheme } = useMantineColorScheme();

  // const originalDataRef = useRef([]);
  const isOriginalDataStored = useRef(false);
  const popoverOpenRef = useRef(false);
  const closedByOutsideClick = useRef(false);

  const modalRef = useClickOutside(() => {
    closedByOutsideClick.current = true;
    if (!popoverOpenRef.current) setIsModalOpen(false);
  });

  const filters = filterConfigDemo[currentTab] || [];

  // useEffect(() => {
  //   // setFilteredData(data);
  //   // originalDataRef.current = data;
  // }, [data]);

  useEffect(() => {
    if (!isModalOpen && closedByOutsideClick.current) {
      setLocalFilterValues({ ...appliedFilters }); // revert to applied
      closedByOutsideClick.current = false; // reset flag
    }
  }, [isModalOpen, appliedFilters]);

  // useEffect(() => {
  //   if (isModalOpen) {
  //     setLocalFilterValues({ ...appliedFilters });
  //   }
  // }, [isModalOpen, appliedFilters]);

  useEffect(() => {
    setLocalFilterValues({});
    // setFilterValues({});
  }, [resetTrigger]);

  const handleClearFilters = () => {
    setLocalFilterValues({});
    // setFilterValues({});
    isOriginalDataStored.current = false;
    setData(originalData);
    handleClear();
    setIsModalOpen(false);
  };

  const applyFilters = (items, selectedFilters) => items.filter((item) => filters.every(({ type, props }) => {
    const fieldKey = props.fieldKey || props.keyName || props.parentKey;
    const value = selectedFilters[fieldKey];
    const handler = filterHandlerMap[type];
    if (!handler) return true;
    return handler(item, props, value);
  }));

  const handleApplyFilters = () => {
    const filtered = applyFilters(originalData, localFilterValues);
    setData(filtered);
    setAppliedFilters(localFilterValues);
    setIsModalOpen(false);
  };

  const renderFilter = (filter, idx) => {
    const { type, props } = filter;
    const fieldKey = props.fieldKey || props.keyName || props.parentKey;

    const commonProps = {
      key: idx,
      data: originalData,
      originalData,
      ...props,
      value: localFilterValues[fieldKey],
      popoverOpenRef,
      setValue: (value) => {
        setLocalFilterValues((prev) => ({
          ...prev,
          [fieldKey]: value,
        }));
      },
    };

    switch (type) {
      case 'dropdown':
        return <NewAssetDropDown {...commonProps} />;
      // case 'range':
      //   return <NewAmountRangeSelector {...commonProps} />;
      case 'range':
        return <CustomRangeSelector {...commonProps} />;
      // case 'number':
      //   return <NewNumberInputComponent {...commonProps} />;
      case 'number':
        return <CustomPercentageField {...commonProps} />;
      case 'dateRange':
        return <ReusableDateRangePicker {...commonProps} />;
      default:
        return null;
    }
  };

  return (
    <div>
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 p-4">
          <div
            ref={modalRef}
            className={`relative w-full max-w-[28rem] max-h-[90vh] h-[84vh] flex flex-col ${colorScheme === 'dark' ? 'bg-[#2b2b2c]' : 'bg-white'} rounded-lg shadow-xl`}
          >
            {/* Static Header */}
            <div className="pt-[2.8125rem] px-[3.1rem] pr-[2.5rem]">
              <h2 className="text-2xl font-bold text-center mb-6">Filters</h2>
            </div>

            {/* Scrollable Filter Fields */}
            <div className="flex-1 overflow-y-auto px-[2.9rem] pr-[2.5rem] pb-4 filter-expansion">
              <div className="flex flex-col gap-6">
                {filters.map((filter, idx) => renderFilter(filter, idx))}
              </div>
            </div>

            {/* Sticky Footer */}
            <div className={`p-4 flex justify-end gap-5 rounded-lg items-center ${colorScheme === 'dark' ? 'bg-[#2b2b2c]' : 'bg-white'}`}>
              <button
                onClick={handleClearFilters}
                className={`${colorScheme === 'dark' ? 'bg-black/50' : 'bg-gray-200'} text-md font-semibold px-6 py-2 rounded`}
              >
                Clear All
              </button>
              <button
                onClick={handleApplyFilters}
                className="bg-[#33B1FF] text-md font-semibold text-white px-6 py-2 rounded"
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterContainer;
